module.exports = __webpack_public_path__ + "static/img/title_2.230bb3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new/title_2.png
// module id = vPDI
// module chunks = 1